import { useMutation } from '@tanstack/react-query';

import type { MutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

const useCatalogUrlMutation = (method: 'PUT' | 'DELETE') =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<MutationResponse>({ method, url }),
  });

export const useArchiveCatalogCardCategoryMutation = () =>
  useCatalogUrlMutation('PUT');

export const useRestoreCatalogCardCategoryMutation = () =>
  useCatalogUrlMutation('PUT');

export const useDeleteCatalogCardCategoryMutation = () =>
  useCatalogUrlMutation('DELETE');

export const useArchiveCatalogCardMutation = () => useCatalogUrlMutation('PUT');

export const useRestoreCatalogCardMutation = () => useCatalogUrlMutation('PUT');

export const useDeleteCatalogCardMutation = () =>
  useCatalogUrlMutation('DELETE');

// Move reparents the record; `ids` is the target parent's full ordered children list.

export const useMoveCatalogCardCategoryMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: { parent_id: number | null; ids: number[] };
    }) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url: params.url,
        data: params.data,
      }),
  });

export const useMoveCatalogCardMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: { card_category_id: number; ids: number[] };
    }) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url: params.url,
        data: params.data,
      }),
  });
